import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HostedGamesRouting } from './hosted-games.routing';
import { HostedGameApplicationsService, HostedGamesService } from '@hosted-games/infra';
import { InvitationsService } from '@invitations/infra';
import { TeamsService } from '@teams/infra';

@NgModule({
  imports: [RouterModule.forChild(HostedGamesRouting)],
  providers: [HostedGamesService, HostedGameApplicationsService, InvitationsService, TeamsService]
})
export class HostedGamesModule {}
